import React, { Component } from "react";
import Slider from "react-slick";
import lodgingImg1 from '../img/Chill out/lodging/Treetops-13 1.jpg';
import lodgingImg2 from '../img/Chill out/lodging/The Marlborough Exteriors Feb 23 RBPHOTO14_4626 1.jpg';
import lodgingImg3 from '../img/Chill out/lodging/lovetaupo 1.jpg';
import lodgingImg4 from '../img/Chill out/lodging/Aro Ha CREDIT Camilla Rutherford 1.jpg';
import lodgingImg5 from '../img/Chill out/lodging/DGGPH1 1.jpg';
import NextArrow from '../img/Arrow Right.png';
import PrevArrow from '../img/Arrow Left.png'

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block"}}
        onClick={onClick}><img className="arrow" src={NextArrow}/></div>
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}><img className="arrow" src={PrevArrow}/></div>
    );
  }

export default class SimpleSlider extends Component {
  state = {
    showPrevArrow: false,
  };
  handleAfterChange = (currentSlide) => {
    // Show previous arrow after the first slide
    if (currentSlide > 0) {
      this.setState({ showPrevArrow: true });
    } else {
      this.setState({ showPrevArrow: false });
    }
  };
  render() {
    const { showPrevArrow } = this.state;
    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: showPrevArrow ? <SamplePrevArrow /> : null, // Conditionally render the SamplePrevArrow component
        responsive: [
          {
            breakpoint: 1439,
            settings: {
              slidesToShow: 3
            }
          },
            {
              breakpoint: 980,
              settings: {
                slidesToShow: 1,
                variableWidth: false,
              }
            },
        ],
        afterChange: this.handleAfterChange, // Handle slide change event
    };
    return (
      <div className="lodging-carousel">
        <Slider {...settings} className="full-width-carousel">
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg1}/>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">1</h3>
                    <h3>Treetops Lodge & Estate </h3> 
                    <p>All-inclusive resort with dining and experiences for the family</p>
                    <p className="small-text light-italic location desktop">351 Kearoa Road, RD1, Horohoro,<br/>Rotorua, New Zealand</p>
                    <p className="small-text light-italic location mobile">351 Kearoa Road, RD1, Horohoro,<br/>Rotorua, New Zealand</p>
                    <p className="small-text light-italic location sm-desktop">351 Kearoa Road, RD1, Horohoro, Rotorua, <br/>New Zealand</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg2}/>
                    <div className="copyright white">© The Marlborough</div>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">2</h3>
                    <h3>The Marlborough </h3> 
                    <p>Stay in luxury, right in the heart of New Zealand's famous wine region</p>
                    <p className="small-text light-italic location desktop">776 Rapaura Road, Rapaura 7273, <br/>Marlborough, New Zealand</p>
                    <p className="small-text light-italic location mobile">776 Rapaura Road, Rapaura 7273, <br/>Marlborough, New Zealand</p>
                    <p className="small-text light-italic location sm-desktop">776 Rapaura Road, Rapaura 7273, Marlborough, <br/>New Zealand</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg3}/>
                    <div className="copyright white">© Love Taupo</div>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">3</h3>
                    <h3>Lake Taupo Holiday </h3> 
                    <p>Resort Your base for rest and rejuvenation with thermal pools, family activities, and more</p>
                    <p className="small-text light-italic location">41 Centennial Drive, Taupo, Bay Of Plenty, 3351, <br/>New Zealand</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg4}/>
                    <div className="copyright white">© Camilla Rutherford</div>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">4</h3>
                    <h3>Aro Hā Wellness Retreat </h3> 
                    <p>Dedicate your body and soul to a luxurious retreat with everything taken care of</p>
                    <p className="small-text light-italic location">33 Station Valley Rd, Wyuna Rise, Glenorchy 9372, <br/>New Zealand</p>
                </div>  
            </div> 
            <div>
                <div className="thumbnail-img pt-5">
                    <img className="full-width" src={lodgingImg5}/>
                </div>
                <div className="content pt-3 pb-5">
                    <h3 className="number violet">5</h3>
                    <h3>Whakarewarewa</h3> 
                    <p>Experience culture and tradition with an overnight stay in a living Māori village</p>
                </div>  
            </div> 
        </Slider>
      </div>
    );
  }
}